import moment from 'moment';

export const dateUtils = {
  getNotificationsUserFriendlyDate: (timeVal: any) => {
    const requiredDate = moment(timeVal).format('M/D/YY');
    if (requiredDate === moment().format('M/D/YY')) {
      return 'Today';
    }
    if (requiredDate === moment().subtract(1, 'days').format('M/D/YY')) {
      return 'Yesterday';
    }
    return moment(timeVal).format('D MMM YYYY');
  },
  getRunningSinceDateFormat: (date: any) => `${dateUtils.getFormattedDate(date)} ${dateUtils.getFormattedTime(date)}`,
  getFormattedDate: (date: any) => moment(date).format('D MMM YYYY'),
  getFormattedTime: (date: any) => moment(date).format('HH:mm'),
};
